module.exports = __webpack_public_path__ + "img/carrier-logo.beb7b362.png";